import React from "react";
import { ProductForm, type ProductFormData } from "../ProductForm";
import { Product } from "../../types";
import { AdminCategoryItemDto } from "@semo/api-contracts";
import { toast } from "sonner";

interface ProductModificationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  product: Product | null;
  onSubmit: (message: string, modifiedData: Partial<Product>) => void;
}

export const ProductModificationDialog: React.FC<
  ProductModificationDialogProps
> = ({ isOpen, onClose, product, onSubmit }) => {
  const onFormSubmit = (data: ProductFormData) => {
    const { requestReason, ...modifiedFields } = data;

    if (!requestReason?.trim()) {
      toast.error("수정 요청 사유를 입력해주세요.");
      return;
    }

    // Transform ProductFormData back to Partial<Product> for the legacy onSubmit handler
    const modifiedData: Partial<Product> = modifiedFields;

    onSubmit(requestReason, modifiedData);
    onClose();
  };

  if (!product) return null;

  // Map Product domain entity to AdminCategoryItemDto-like structure for the form
  const initialFormData: Partial<AdminCategoryItemDto> = {
    ...product,
    categoryId: product.categoryId ?? undefined,
  };

  return (
    <ProductForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onFormSubmit}
      initialData={initialFormData}
      title="상품 정보 수정 요청"
      submitLabel="요청 보내기"
      categoryId={product.categoryId ?? ""}
      categoryName=""
      sections={{
        category: false,
        basicInfo: true,
        specs: true,
        pricing: true,
        image: true,
        requestReason: true,
      }}
    />
  );
};
